module.exports = __webpack_public_path__ + "static/rooster-crow-2-776f8ef57e189a82329b15375da86f60.png";